<template>
    <div class="d-flex align-center flex-column">
        <v-card>
            <s-toolbar label="Devolución de Equipos" dark :color="'#8e8f91'" close @close="$emit('close')"
                class="mb-6"></s-toolbar>
            <v-card-title style="font-size: small;">
                <v-row>
                    <v-col align="right">
                        <v-btn fab style="margin-right: 40px;" x-small color="warning" @click="downloadPdf(1)"> <v-icon
                                medium>mdi-printer</v-icon>
                        </v-btn>
                        <v-btn fab style="margin-right: 40px;" x-small color="info" @click="downloadPdf(0)"> <v-icon
                                medium>mdi-folder-google-drive</v-icon>
                        </v-btn>
                        <v-btn fab x-small color="success" @click="saveSignaturesAndFingerPrints()"> <v-icon
                                medium>mdi-content-save</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <hr>
            <!-- <v-container v-if="$fun.isAdmin()" fluid class="py-1">
                <v-row dense align="center">
                    <v-col cols="12" md="4">
                        <s-select :items="supportUsers" item-text="NtpFullName" item-value="UsrID"
                            v-model="selectedSupportUsrID" label="Técnico Responsable" clearable
                            :autocomplete="true" :slotTmp="true"
                            @change="onSupportUserChanged">
                            <template v-slot:item="{ item }">
                                {{ item.NtpFullName }} - {{ item.PrsDocumentNumber }}
                            </template>
                        </s-select>
                    </v-col>
                </v-row>
            </v-container> -->
            <vue-html2pdf :show-layout="true" :float-layout="false" :enable-download="false" :preview-modal="false"
                :filename="'Devolución.pdf'" :paginate-elements-by-height="1200" :pdf-quality="2" pdf-format="a4"
                pdf-orientation="portrait" pdf-content-width="100%" :manual-pagination="true"
                :htmlToPdfOptions="htmlToPdfOptions" @progress="onProgress($event)" @startPagination="startPagination()"
                @hasPaginated="hasPaginated()" @beforeDownload="beforeDownload($event)"
                @hasDownloaded="hasDownloaded($event)" ref="html2Pdf">
                <section slot="pdf-content">
                    <div
                        style="font-family: Arial, Helvetica, sans-serif; width: 100%; max-width: 750px; margin: 0 auto; padding: 0 20px 15px 20px; box-sizing: border-box; font-size: 11px;">
                        <!-- Encabezado con 3 secciones -->
                        <div style="display: flex; width: 100%;">
                            <!-- Sección Izquierda - Logo -->
                            <div
                                style="flex: 1; display: flex; justify-content: center; align-items: center;  padding: 10px;">
                                <img src="/static/logo_sp.png" alt="Logo" style="width: 140px; height: auto;">
                            </div>

                            <!-- Sección Central - Título -->
                            <div
                                style="flex: 1.5; display: flex; justify-content: center; align-items: center;  padding: 10px; text-align: center;">
                                <h2 style="margin: 0; font-size: 13px; font-weight: bold; line-height: 14px;">ACTA DE
                                    DEVOLUCIÓN DE
                                    EQUIPO INFORMÁTICO</h2>
                            </div>

                            <!-- Sección Derecha - Información -->
                            <div style="flex: 1; font-size: 9.5px; text-align: center; border-bottom: 2px solid #000; font-weight: bold; line-height: 12px;"
                                @dblclick="openEditModal">
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">
                                        CÓDIGO&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{ formData?.codigo }}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">
                                        VERSIÓN&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{ formData?.version }}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">Fecha de
                                        Creación&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{ formData?.fechaCreacion }}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">Última
                                        Revisión&nbsp;&nbsp;&nbsp;:
                                    </div>
                                    <div style="flex: 1; text-align: start;">{{ formData?.ultimaRevision }}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">
                                        Páginas&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{ formData?.paginas }}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">
                                        Anexo&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{ formData?.anexo }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Banner de Vista Previa si no se ha registrado la devolución -->
                        <div v-if="!item.EanDateDevolution" style="background-color: #ffe6e6; color: #d93838; border: 2px dashed #d93838; padding: 12px; margin-top: 15px; text-align: center; font-weight: bold; font-size: 13px; border-radius: 6px;">
                            VISTA PREVIA - DEVOLUCIÓN NO REGISTRADA EN EL SISTEMA
                        </div>

                        <!-- Contenido principal -->
                        <div style="page-break-inside: avoid; break-inside: avoid;">
                            <div
                                style="display: flex; width: 100%; margin-top: 20px; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px;">
                                Datos de Usuario
                            </div>
                            <div style="display: flex; width: 100%;">
                                <div style="display: flex; flex: 1;">
                                    <div
                                        style="background-color: #F2F2F2; font-weight: bold; width: 80px; padding: 2px 10px;">
                                        Nombre</div>
                                    <div
                                        style="width: 100%; padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                        {{ item.NtpFullName }}</div>
                                </div>
                                <div style="display: flex; flex: 1;">
                                    <div
                                        style="background-color: #F2F2F2; font-weight: bold; width: 80px; padding: 2px 10px;">
                                        DNI
                                    </div>
                                    <div
                                        style="width: 100%; padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                        {{ item.PrsDocumentNumber }}</div>
                                </div>
                            </div>
                            <div style="display: flex; width: 100%;">
                                <div style="display: flex; flex: 1;">
                                    <div
                                        style="background-color: #F2F2F2; font-weight: bold; width: 80px; padding: 2px 10px;">
                                        Cargo
                                    </div>
                                    <div
                                        style="width: 100%; padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                        {{ item.PstName }}</div>
                                </div>
                                <div style="display: flex; flex: 1;">
                                    <div
                                        style="background-color: #F2F2F2; font-weight: bold; width: 80px; padding: 2px 10px;">
                                        Área
                                    </div>
                                    <div
                                        style="width: 100%; padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                        {{ item.AreName }}</div>
                                </div>
                            </div>
                        </div>

                        <template v-for="(itemDetail) in sortedItemsDetail">
                            <!-- ========== EQUIPO ESTÁNDAR (PC / Laptop / Otros) ========== -->
                            <template v-if="itemDetail.CgeTypeEquipment != CELLPHONE_TYPE_ID">
                                <div style="page-break-inside: avoid; break-inside: avoid;">
                                    <div
                                        style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px; margin-top: 20px;">
                                        Datos del Equipo (PC / Laptop / Otros)</div>
                                    <div
                                        style="display: grid; grid-template-columns: 120px 143.3px 80px 143.3px 80px 143.3px; width: 100%; line-height: 14px;">
                                        <div
                                            style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2; grid-row: span 2 / span 2;">
                                            Tipo de Equipo</div>
                                        <div
                                            style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word; grid-row: span 2 / span 2;">
                                            {{ itemDetail.CgeTypeEquipmentName }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                            Marca</div>
                                        <div
                                            style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                            {{ itemDetail.CgeBrandName }}</div>
                                        <div
                                            style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2; grid-column-start: 3; grid-row-start: 2;">
                                            Número de Serie</div>
                                        <div
                                            style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word; grid-column-start: 4; grid-row-start: 2;">
                                            {{ itemDetail.CgeSerie }}</div>
                                        <div
                                            style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2; grid-row: span 2 / span 2; grid-column-start: 5; grid-row-start: 1;">
                                            Modelo</div>
                                        <div
                                            style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word; grid-row: span 2 / span 2; grid-column-start: 6; grid-row-start: 1;">
                                            {{ itemDetail.CgeModelName }}</div>
                                    </div>
                                    <div v-if="itemDetail.TdtObservation"
                                        style="display: flex; width: 100%; margin-top: 2px;">
                                        <div
                                            style="font-weight: bold; padding: 2px 10px; width: 110px; background-color: #F2F2F2;">
                                            Obs. del Equipo</div>
                                        <div
                                            style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                            {{ itemDetail.TdtObservation }}</div>
                                    </div>
                                    <div
                                        style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px;">
                                        Accesorios</div>
                                    <template v-for="(itemAccessory) in itemDetail.ItemsAccessory">
                                        <div v-if="validatedItems(itemAccessory)"
                                            style="display: grid; grid-template-columns: repeat(7, 101.43px); width: 100%; line-height: 14px;">
                                            <div
                                                style="background-color: #D9D9D9; font-weight: bold; padding: 2px 10px;">
                                                {{ itemAccessory.EayAccessoryName }}</div>
                                            <div
                                                style="padding: 2px 10px; word-break: break-word; overflow-wrap: break-word; background-color: #F2F2F2; font-weight: bold;">
                                                Marca</div>
                                            <div
                                                style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                                {{ itemAccessory.EayBrandName }}</div>
                                            <div
                                                style="padding: 2px 10px; word-break: break-word; overflow-wrap: break-word; background-color: #F2F2F2; font-weight: bold;">
                                                Modelo</div>
                                            <div
                                                style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                                {{ itemAccessory.EayModelName }}</div>
                                            <div
                                                style="padding: 2px 10px; word-break: break-word; overflow-wrap: break-word; background-color: #F2F2F2; font-weight: bold;">
                                                Serie</div>
                                            <div
                                                style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                                {{ itemAccessory.EaySerie }}</div>
                                        </div>
                                        <div v-else
                                            style="display: grid; grid-template-columns: 101.43px 1fr; width: 100%; line-height: 14px;">
                                            <div
                                                style="background-color: #D9D9D9; font-weight: bold; padding: 2px 10px;">
                                                {{ itemAccessory.EayAccessoryName }}</div>
                                            <div
                                                style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                                {{ itemAccessory.EayObservation }}</div>
                                        </div>
                                    </template>
                                </div>
                            </template>

                            <!-- ========== CELULAR / SMARTPHONE ========== -->
                            <template v-else>
                                <div style="page-break-inside: avoid; break-inside: avoid;">
                                    <div
                                        style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px; margin-top: 20px;">
                                        Datos del Equipo (Celular / Smartphone)</div>
                                    <div
                                        style="display: grid; grid-template-columns: 120px 1fr 120px 1fr; width: 100%; line-height: 14px;">
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                            Marca</div>
                                        <div style="padding: 2px 5px; word-break: break-word;">{{
                                            itemDetail.CgeBrandName }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                            Modelo</div>
                                        <div style="padding: 2px 5px; word-break: break-word;">{{
                                            itemDetail.CgeModelName }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                            IMEI</div>
                                        <div style="padding: 2px 5px; word-break: break-word;">{{ itemDetail.CgeSerie ||
                                            itemDetail.CgeHostname }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">N°
                                            Celular</div>
                                        <div style="padding: 2px 5px; word-break: break-word;">{{
                                            getSimAccessory(itemDetail.ItemsAccessory).EayPhoneNumber || 'No asignado'
                                        }}</div>
                                    </div>

                                    <div v-if="itemDetail.TdtObservation"
                                        style="display: flex; width: 100%; margin-top: 2px;">
                                        <div
                                            style="font-weight: bold; padding: 2px 10px; width: 110px; background-color: #F2F2F2;">
                                            Obs. del Equipo</div>
                                        <div
                                            style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                            {{ itemDetail.TdtObservation }}</div>
                                    </div>

                                    <div
                                        style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px;">
                                        Detalles del Equipo</div>
                                    <div
                                        style="display: grid; grid-template-columns: 120px 1fr 120px 1fr 120px 1fr; width: 100%; line-height: 14px;">
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                            Procesador</div>
                                        <div style="padding: 2px 5px; word-break: break-word;">{{
                                            getCharacteristic(itemDetail.ItemsCharacteristics, 1) || '-' }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                            RAM</div>
                                        <div style="padding: 2px 5px; word-break: break-word;">{{
                                            getCharacteristic(itemDetail.ItemsCharacteristics, 2) || '-' }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                            Almacenamiento</div>
                                        <div style="padding: 2px 5px; word-break: break-word;">{{
                                            getCharacteristic(itemDetail.ItemsCharacteristics, 6) || '-' }}</div>
                                    </div>

                                    <div
                                        style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px;">
                                        Accesorios</div>
                                    <div style="width: 100%; line-height: 14px; border: 1px solid #ccc;">
                                        <div
                                            style="display: grid; grid-template-columns: 110px 1fr 90px 70px 1fr; width: 100%; background-color: #D9D9D9; font-weight: bold;">
                                            <div style="padding: 2px 10px;">Accesorio</div>
                                            <div style="padding: 2px 5px;">Marca</div>
                                            <div style="padding: 2px 5px;">Potencia (W)</div>
                                            <div style="padding: 2px 0px; text-align: center;">Cable Datos</div>
                                            <div style="padding: 2px 5px;">Tipo de Cable</div>
                                        </div>
                                        <div
                                            style="display: grid; grid-template-columns: 110px 1fr 90px 70px 1fr; width: 100%;">
                                            <div
                                                style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                                Adaptador CD</div>
                                            <div style="padding: 2px 5px;">{{
                                                getChargerAccessory(itemDetail.ItemsAccessory).EayBrandName || '-' }}
                                            </div>
                                            <div style="padding: 2px 5px;">{{
                                                getChargerAccessory(itemDetail.ItemsAccessory).EayWattage || '-' }}
                                            </div>
                                            <div style="padding: 2px 0px; text-align: center;">{{
                                                getChargerAccessory(itemDetail.ItemsAccessory).EayHasDataCable ? 'Sí' :
                                                    'No' }}</div>
                                            <div style="padding: 2px 5px;">{{
                                                getChargerAccessory(itemDetail.ItemsAccessory).EayCableTypeName || '-'
                                            }}</div>
                                        </div>
                                        <div
                                            style="display: grid; grid-template-columns: 110px 1fr 90px 70px 1fr; width: 100%; background-color: #F9F9F9;">
                                            <div
                                                style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">
                                                SimCard</div>
                                            <div style="padding: 2px 5px;">
                                                <div><strong>Operador:</strong> {{
                                                    getSimAccessory(itemDetail.ItemsAccessory).OperatorName || '-' }}
                                                </div>
                                                <div v-if="getSimAccessory(itemDetail.ItemsAccessory).CppName">
                                                    <strong>Plan:</strong> {{
                                                        getSimAccessory(itemDetail.ItemsAccessory).CppName }}
                                                </div>
                                            </div>
                                            <div style="padding: 2px 5px;">
                                                <div v-if="getSimAccessory(itemDetail.ItemsAccessory).EayPhoneNumber">
                                                    <strong>N°:</strong> {{
                                                        getSimAccessory(itemDetail.ItemsAccessory).EayPhoneNumber }}
                                                </div>
                                            </div>
                                            <div style="padding: 2px 0px; text-align: center;">-</div>
                                            <div style="padding: 2px 5px;"><strong>IMEI:</strong> {{
                                                getSimAccessory(itemDetail.ItemsAccessory).EaySerie || '-' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <!-- Observaciones Generales -->
                        <div style="page-break-inside: avoid; break-inside: avoid;">
                            <div
                                style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px; margin-top: 40px;">
                                Observaciones Generales
                            </div>
                            <div style="background-color: #F2F2F2; width: 100%; min-height: 150px; cursor: pointer; position: relative;"
                                ref="observationContainer">
                                <textarea v-if="isEditing" v-model="EanTextObservationDevolution"
                                    style="padding: 2px 10px; border: none; min-height: 150px; width: 100%; outline: none; line-height: 14px;"
                                    @click.stop></textarea>
                                <div v-else v-html="formattedEanTextObservationDevolution"
                                    style="padding: 2px 10px; min-height: 150px; line-height: 14px; font-size: 11px;"
                                    @click="activateEditing"></div>
                            </div>
                        </div>

                        <!-- Firmas -->
                        <div style="page-break-inside: avoid; break-inside: avoid;">
                            <div style="display: flex; margin-top: 40px;">
                                <div style="flex: 1; margin-top: 80px; display: flex; justify-content: center;">
                                    <p
                                        style="font-size: 12px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 0;">
                                    <div
                                        style="display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; max-width: max-content;">
                                        <div
                                            style="width: 100%; height: 80px; display: flex; justify-content: center; align-items: center; position: absolute; top: -80px;">
                                            <div style="width: 100%; display: flex;" v-if="item.EanDateDevolution">
                                                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; cursor: pointer;"
                                                    @click="funDialogSignatureUser()">
                                                    <span
                                                        v-if="!EanSignatureUserDevolution && !EanSignatureUserDevolutionDB"
                                                        style="height:80px; width: 100%;"></span>
                                                    <img :src="EanSignatureUserDevolution"
                                                        v-if="EanSignatureUserDevolution" alt="Firma Usuario"
                                                        style="max-width: 100%; height: 80px; object-fit: contain; padding: 5px;" />
                                                    <img :src="EanSignatureUserDevolutionDB"
                                                        v-if="!EanSignatureUserDevolution && EanSignatureUserDevolutionDB"
                                                        alt="Firma Usuario"
                                                        style="max-width: 100%; height: 80px; object-fit: contain; padding: 5px;" />
                                                </div>
                                                <div
                                                    style="width: 60px; height: 80px; border: 1px solid #000; text-align: center; display: flex; justify-content: center; align-items: center;">
                                                    <s-finger-print
                                                        v-if="EanFingerPrintUserDevolutionDB && !EanFingerPrintUserDevolution"
                                                        contentIMG :srcImg="EanFingerPrintUserDevolutionDB" notBtn
                                                        :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }"
                                                        @fingerprintSaved="handleFingerprintUser"></s-finger-print>
                                                    <s-finger-print
                                                        v-if="!EanFingerPrintUserDevolutionDB && !EanFingerPrintUserDevolution"
                                                        contentIMG notBtn
                                                        :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }"
                                                        @fingerprintSaved="handleFingerprintUser"></s-finger-print>
                                                    <s-finger-print v-if="EanFingerPrintUserDevolution" contentIMG
                                                        :srcImg="EanFingerPrintUserDevolution" notBtn
                                                        :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }"
                                                        @fingerprintSaved="handleFingerprintUser"></s-finger-print>
                                                </div>
                                            </div>
                                            <div style="width: 100%; display: flex;" v-else>
                                                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%;">
                                                    <span style="height: 80px; width: 100%;"></span>
                                                </div>
                                                <div
                                                    style="width: 60px; height: 80px; border: 1px dashed #ccc; text-align: center; display: flex; justify-content: center; align-items: center;">
                                                    <span style="font-size: 8px; color: #999;">Huella</span>
                                                </div>
                                            </div>
                                        </div>
                                        <span style="border-top: 1px solid #000;">&nbsp;&nbsp;&nbsp;&nbsp; <span
                                                style="font-weight: bold;">Nombre : </span>{{ item.NtpFullName
                                                }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        <span><span style="font-weight: bold;">DNI : </span>{{ item.PrsDocumentNumber
                                        }}</span>
                                        <span><span style="font-weight: bold;">Fecha : </span>{{
                                            item.EanDateDevolution ? this.$fun.formatDateView(item.EanDateDevolution) : '' }}</span>
                                    </div>
                                    </p>
                                </div>
                                <div style="flex: 1; margin-top: 80px; display: flex; justify-content: center;">
                                    <p
                                        style="font-size: 12px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 0;">
                                    <div
                                        style="display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; max-width: max-content;">
                                        <div
                                            style="width: 100%; height: 80px; display: flex; justify-content: center; align-items: center; position: absolute; top: -80px;">
                                            <div style="width: 100%; display: flex;" v-if="item.EanDateDevolution">
                                                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; cursor: pointer;"
                                                    @click="funDialogSignatureResponsible">
                                                    <span style="height:80px; width: 100%;"
                                                        v-if="!EanSignatureResponsibleDevolution && !EanSignatureResponsibleDevolutionDB"></span>
                                                    <img :src="EanSignatureResponsibleDevolution"
                                                        v-if="EanSignatureResponsibleDevolution" alt="Firma Responsable"
                                                        style="max-width: 80%; height: 80px; object-fit: contain; padding: 5px;" />
                                                    <img :src="EanSignatureResponsibleDevolutionDB"
                                                        v-if="EanSignatureResponsibleDevolutionDB && !EanSignatureResponsibleDevolution"
                                                        alt="Firma Responsable"
                                                        style="max-width: 80%; height: 80px; object-fit: contain; padding: 5px;" />
                                                </div>
                                                <div
                                                    style="width: 60px; height: 80px; border: 1px solid #000; text-align: center; display: flex; justify-content: center; align-items: center;">
                                                    <s-finger-print
                                                        v-if="EanFingerPrintResponsibleDevolutionDB && !EanFingerPrintResponsibleDevolution"
                                                        contentIMG :srcImg="EanFingerPrintResponsibleDevolutionDB"
                                                        notBtn
                                                        :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }"
                                                        @fingerprintSaved="handleFingerprintResponsible"></s-finger-print>
                                                    <s-finger-print
                                                        v-if="!EanFingerPrintResponsibleDevolutionDB && !EanFingerPrintResponsibleDevolution"
                                                        contentIMG notBtn
                                                        :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }"
                                                        @fingerprintSaved="handleFingerprintResponsible"></s-finger-print>
                                                    <s-finger-print v-if="EanFingerPrintResponsibleDevolution"
                                                        contentIMG :srcImg="EanFingerPrintResponsibleDevolution" notBtn
                                                        :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }"
                                                        @fingerprintSaved="handleFingerprintResponsible"></s-finger-print>
                                                </div>
                                            </div>
                                            <div style="width: 100%; display: flex;" v-else>
                                                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%;">
                                                    <span style="height: 80px; width: 100%;"></span>
                                                </div>
                                                <div
                                                    style="width: 60px; height: 80px; border: 1px dashed #ccc; text-align: center; display: flex; justify-content: center; align-items: center;">
                                                    <span style="font-size: 8px; color: #999;">Huella</span>
                                                </div>
                                            </div>
                                        </div>
                                        <span
                                            style="border-top: 1px solid #000; min-width: 240px;">&nbsp;&nbsp;&nbsp;&nbsp;<span
                                                style="font-weight: bold;">Nombre : </span>{{ item.EanDateDevolution ? (item.UsrDevolutionName ?
                                                    item.UsrDevolutionName :
                                                    (item.UsrCreateName ? item.UsrCreateName : this.$fun.getUserInfo().NtpFullName)) : '' }} &nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        <span><span style="font-weight: bold;">DNI : </span>{{
                                            item.EanDateDevolution ? (item.UsrDevolutionPrsDocumentNumber ?
                                                item.UsrDevolutionPrsDocumentNumber : 
                                                (item.UsrCreatePrsDocumentNumber ? item.UsrCreatePrsDocumentNumber : this.$fun.getUserInfo().PrsDocumentNumber)) : ''
                                        }}</span>
                                        <span><span style="font-weight: bold;">Fecha : </span>{{
                                            item.EanDateDevolution ? this.$fun.formatDateView(item.EanDateDevolution) : '' }}</span>
                                    </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </vue-html2pdf>
        </v-card>
        <v-dialog v-model="dialogSignatureUser" v-if="dialogSignatureUser" max-width="800px" persistent>
            <v-card>
                <s-toolbar label="Firma del Usuario" dark color="#8e8f91" close
                    @close="dialogSignatureUser = false"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col>
                            <s-signature-pad ref="signaturePadUser" style="height: 400px;"
                                @save-signature="handleSignatureUser" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSignatureResponsible" v-if="dialogSignatureResponsible" max-width="800px" persistent>
            <v-card>
                <s-toolbar label="Firma del Responsable" dark color="#8e8f91" close
                    @close="dialogSignatureResponsible = false"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col>
                            <s-signature-pad ref="signaturePadResponsible" style="height: 400px;"
                                @save-signature="handleSignatureResponsible" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editModal" max-width="500px">
            <v-card>
                <s-toolbar label="Editar Datos del Formulario" dark color="#8e8f91" close
                    @close="editModal = false"></s-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <s-text v-model="editForm.codigo" label="Código"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.version" label="Versión"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.fechaCreacion" label="Fecha de Creación"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.ultimaRevision" label="Última Revisión"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.paginas" label="Última Revisión"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.anexo" label="Anexo"></s-text>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="editModal = false">Cancelar</v-btn>
                    <v-btn color="success" @click="saveFormData">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import _sHelper from "@/services/HelperService";
import EquimentAssignamentNew from "../../../services/InformationTechnology/EquimentAssignamentNew";
import GenUploadFiles from "../../../services/General/GenUploadFiles";
import sFingerPrint from "@/components/Utils/RecursosHm/sFingerPrint";
import _sGenParam from "@/services/General/ParameterService";
import SupportUserService from "../../../services/InformationTechnology/SupportUserService";

export default {

    props: {
        item: {
            type: Object,
            default: null,
        },
    },
    components: {
        VueHtml2pdf,
        sFingerPrint
    },
    data() {
        return {
            CELLPHONE_TYPE_ID: 8,
            EanSignatureUserDevolution: null,
            EanFingerPrintUserDevolution: null,
            EanSignatureResponsibleDevolution: null,
            EanFingerPrintResponsibleDevolution: null,

            EanSignatureUserDevolutionDB: null,
            EanFingerPrintUserDevolutionDB: null,
            EanSignatureResponsibleDevolutionDB: null,
            EanFingerPrintResponsibleDevolutionDB: null,

            supportUsers: [],
            selectedSupportUsrID: null,
            isEditing: false,
            EanTextObservationDevolution: "",
            dialogSignatureUser: false,
            dialogSignatureResponsible: false,
            htmlToPdfOptions: {
                margin: [0.4, 0.3, 0.6, 0.3],
                filename: `Devolución_${this.item.EanID}_a_${this.item.PrsDocumentNumber}.pdf`,
                pagebreak: { mode: ['css', 'legacy'] },
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'portrait'
                },
                html2canvas: {
                    useCORS: true,
                    scale: 3,
                },
            },
            rootFolderId: null,
            client_id: null,
            download: 1,

            formData: {},
            editForm: {
                codigo: "",
                version: "",
                fechaCreacion: "",
                ultimaRevision: "",
                paginas: "",
                anexo: ""
            },
            editModal: false,
            dataAttributes: {}
        }
    },
    methods: {
        openEditModal() {
            if (!this.$fun.isAdmin()) return;
            this.editForm = { ...this.formData };
            this.editModal = true;
        },
        saveFormData() {
            const data = { ...this.dataAttributes }
            data.PrmValue = JSON.stringify(this.editForm);
            _sGenParam.save(data, this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                    this.editModal = false;
                    this.getData();
                }
            })
        },
        getData() {
            _sGenParam
                .listoptions({ Search: "PdfDevolution" }, this.$fun.getUserID())
                .then((resp) => {
                    if (resp.status == 200) {
                        if (!resp.data.length) return;
                        this.dataAttributes = resp.data[0];
                        this.formData = { ...JSON.parse(this.dataAttributes.PrmValue) } || {};
                        console.log(resp.data[0]);
                    }
                });
        },
        handleClickOutside(event) {
            if (this.$refs.observationContainer && !this.$refs.observationContainer.contains(event.target)) {
                this.isEditing = false;
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        activateEditing(event) {
            event.stopPropagation();
            this.isEditing = true;

            setTimeout(() => {
                document.addEventListener("click", this.handleClickOutside);
            });
        },
        loginWithGoogle(callback) {
            const client = google.accounts.oauth2.initTokenClient({
                client_id: this.client_id,
                scope: 'https://www.googleapis.com/auth/drive.file',
                callback: (response) => {
                    if (response && response.access_token) {
                        this.googleAccessToken = response.access_token;
                        if (typeof callback === 'function') callback();
                    } else {
                        console.error('Fallo en login GIS', response);
                    }
                },
            });

            client.requestAccessToken();
        },
        async uploadPdfToDrive(blob, fileName) {
            const rootFolderId = this.rootFolderId;
            const areaFolderId = await this.getOrCreateFolder(this.item.AreName, rootFolderId);

            const fileId = await this.findFileIdByName(fileName, areaFolderId);

            const metadata = fileId
                ? { name: fileName, mimeType: 'application/pdf' }
                : { name: fileName, mimeType: 'application/pdf', parents: [areaFolderId] };

            const form = new FormData();
            form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
            form.append('file', blob);

            const url = fileId
                ? `https://www.googleapis.com/upload/drive/v3/files/${fileId}?uploadType=multipart`
                : `https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart`;

            const method = fileId ? 'PATCH' : 'POST';

            try {
                const res = await fetch(url, {
                    method,
                    headers: new Headers({ Authorization: `Bearer ${this.googleAccessToken}` }),
                    body: form
                });

                const json = await res.json();
                console.log(fileId ? 'Archivo reemplazado' : 'Archivo subido nuevo', json);
                this.$fun.alert(`¡PDF ${fileId ? 'reemplazado' : 'subido'} correctamente!`, "success");
            } catch (err) {
                console.error('Error subiendo/reemplazando PDF:', err);
                this.$fun.alert("Error subiendo el PDF a Drive", "error");
            }
        },
        async findFileIdByName(fileName, parentId) {
            const query = `name='${fileName}' and '${parentId}' in parents and trashed = false`;
            const res = await fetch(`https://www.googleapis.com/drive/v3/files?q=${encodeURIComponent(query)}&fields=files(id,name)`, {
                headers: {
                    Authorization: `Bearer ${this.googleAccessToken}`,
                },
            });

            const data = await res.json();
            return data.files?.[0]?.id || null;
        },
        async getOrCreateFolder(folderName, rootFolderId) {
            const sanitizedFolderName = folderName.replace(/[\\/#%&{}<>*? $!'":@+`|=]/g, '_').trim();

            const query = `name='${sanitizedFolderName}' and mimeType='application/vnd.google-apps.folder' and '${rootFolderId}' in parents and trashed=false`;
            const res = await fetch(`https://www.googleapis.com/drive/v3/files?q=${encodeURIComponent(query)}&fields=files(id,name)`, {
                headers: {
                    Authorization: `Bearer ${this.googleAccessToken}`
                }
            });

            const data = await res.json();
            if (data.files && data.files.length > 0) {
                return data.files[0].id;
            }

            const metadata = {
                name: sanitizedFolderName,
                mimeType: 'application/vnd.google-apps.folder',
                parents: [rootFolderId]
            };

            const createRes = await fetch('https://www.googleapis.com/drive/v3/files', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${this.googleAccessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(metadata)
            });

            const folder = await createRes.json();
            return folder.id;
        },
        funDialogSignatureUser() {
            this.dialogSignatureUser = true;
        },
        funDialogSignatureResponsible() {
            this.dialogSignatureResponsible = true;
        },
        handleSignatureUser(image) {
            this.EanSignatureUserDevolution = image;
            this.dialogSignatureUser = false;
        },
        handleSignatureResponsible(image) {
            this.EanSignatureResponsibleDevolution = image;
            this.dialogSignatureResponsible = false;
        },
        handleFingerprintUser(image) {
            this.EanFingerPrintUserDevolution = image;
        },
        handleFingerprintResponsible(image) {
            this.EanFingerPrintResponsibleDevolution = image;
        },
        validatedItems(item) {
            if (!item.EayBrand && !item.EayModel && !item.EaySerie) {
                return false;
            } else {
                return true;
            }
        },
        getCharacteristic(chars, typeId) {
            if (!chars) return null;
            const found = chars.find(function (c) { return c.EctCharacteristics == typeId; });
            return found ? found.EctValueCharacteristics : null;
        },
        getSimAccessory(accessories) {
            if (!accessories) return {};
            return accessories.find(function (a) { return a.EayAccessory == 14; }) || {};
        },
        getChargerAccessory(accessories) {
            if (!accessories) return {};
            return accessories.find(function (a) { return a.EayAccessory == 2; }) || {};
        },
        downloadPdf(download) {
            this.download = download;
            this.$refs.html2Pdf.generatePdf();
        },
        onProgress(progress) {
            this.progress = progress;
        },
        startPagination() {
        },

        hasPaginated() {
        },

        beforeDownload({ html2pdf, options, pdfContent }) {

            if (!this.download) {
                html2pdf()
                    .set(options)
                    .from(pdfContent)
                    .toPdf()
                    .get('pdf')
                    .then((pdf) => {
                        const totalPages = pdf.internal.getNumberOfPages();
                        const pageWidth = pdf.internal.pageSize.getWidth();
                        const pageHeight = pdf.internal.pageSize.getHeight();

                        for (let i = 2; i <= totalPages; i++) {
                            pdf.setPage(i);
                            pdf.setFillColor(255, 255, 255);
                            pdf.rect(0, 0, pageWidth, 1.05, 'F');
                            pdf.setFontSize(7);
                            pdf.setTextColor(0);
                            pdf.text('ACTA DE DEVOLUCIÓN DE EQUIPO INFORMÁTICO',
                                pageWidth / 2, 0.55, { align: 'center' });
                            pdf.setDrawColor(0);
                            pdf.setLineWidth(0.005);
                            pdf.line(0.5, 0.72, pageWidth - 0.5, 0.72);
                        }
                        for (let i = 1; i <= totalPages; i++) {
                            pdf.setPage(i);
                            pdf.setFontSize(8);
                            pdf.setTextColor(100);
                            pdf.text('Página ' + i + ' de ' + totalPages, pageWidth - 0.5, pageHeight - 0.35, { align: 'right' });
                        }

                        const pdfBlob = pdf.output('blob');
                        const fileName = options.filename || `Devolución_${this.item.EanID}_a_${this.item.PrsDocumentNumber}.pdf`;

                        if (this.googleAccessToken) {
                            this.uploadPdfToDrive(pdfBlob, fileName);
                        } else {
                            this.loginWithGoogle(() => {
                                this.uploadPdfToDrive(pdfBlob, fileName);
                            });
                        }
                    });

                return false;
            } else {
                html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages();
                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();

                    for (let i = 2; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFillColor(255, 255, 255);
                        pdf.rect(0, 0, pageWidth, 1.05, 'F');
                        pdf.setFontSize(7);
                        pdf.setTextColor(0);
                        pdf.text('ACTA DE DEVOLUCIÓN DE EQUIPO INFORMÁTICO',
                            pageWidth / 2, 0.55, { align: 'center' });
                        pdf.setDrawColor(0);
                        pdf.setLineWidth(0.005);
                        pdf.line(0.5, 0.72, pageWidth - 0.5, 0.72);
                    }
                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(100);
                        pdf.text('Página ' + i + ' de ' + totalPages,
                            pageWidth - 0.5, pageHeight - 0.35, { align: 'right' });
                    }
                }).save()
            }
        },
        saveSignaturesAndFingerPrints() {
            // Use selected support user if chosen, otherwise fallback to current user
            if (this.selectedSupportUsrID) {
                this.item.UsrDevolutionID = this.selectedSupportUsrID;
            } else {
                this.item.UsrDevolutionID = this.$fun.getUserID();
            }
            // Set devolution date to current date when signing if not already set
            if (!this.item.EanDateDevolution) {
                this.item.EanDateDevolution = new Date();
            }
            this.item.EanTextObservationDevolution = this.EanTextObservationDevolution;
            this.isEditing = false;
            this.$fun.alert("¿Seguro de guardar?", "question")
                .then(async r => {
                    if (r.value) {

                        if (this.EanSignatureUserDevolution) {
                            try {
                                const respImg = await GenUploadFiles.upload(this.EanSignatureUserDevolution, `EanSignatureUserDevolution_${this.item.EanID}`, 'routeTIInfraestructura', true);
                                this.item.EanSignatureUserDevolution = respImg.data.fileName;
                            } catch (error) {
                                this.$fun.alert("Error al subir la foto", "warning");
                                console.error("Error al subir la foto", error);
                            }
                        }

                        if (this.EanSignatureResponsibleDevolution) {
                            try {
                                const respImg = await GenUploadFiles.upload(this.EanSignatureResponsibleDevolution, `EanSignatureResponsibleDevolution_${this.item.EanID}`, 'routeTIInfraestructura', true);
                                this.item.EanSignatureResponsibleDevolution = respImg.data.fileName;
                            } catch (error) {
                                this.$fun.alert("Error al subir la foto", "warning");
                                console.error("Error al subir la foto", error);
                            }
                        }

                        if (this.EanFingerPrintUserDevolution) {
                            try {
                                const respImg = await GenUploadFiles.upload(this.EanFingerPrintUserDevolution, `EanFingerPrintUserDevolution_${this.item.EanID}`, 'routeTIInfraestructura', true);
                                this.item.EanFingerPrintUserDevolution = respImg.data.fileName;
                            } catch (error) {
                                this.$fun.alert("Error al subir la foto", "warning");
                                console.error("Error al subir la foto", error);
                            }
                        }

                        if (this.EanFingerPrintResponsibleDevolution) {
                            try {
                                const respImg = await GenUploadFiles.upload(this.EanFingerPrintResponsibleDevolution, `EanFingerPrintResponsibleDevolution_${this.item.EanID}`, 'routeTIInfraestructura', true);
                                this.item.EanFingerPrintResponsibleDevolution = respImg.data.fileName;
                            } catch (error) {
                                this.$fun.alert("Error al subir la foto", "warning");
                                console.error("Error al subir la foto", error);
                            }
                        }

                        await EquimentAssignamentNew.save(this.item, this.$fun.getUserID());
                        this.$fun.alert("Se ha guardado correctamente", "success");
                    }
                });
        },
        /* loadSupportUsers() {
            const self = this;
            const requestID = this.$fun.getUserID();
            console.log("TicSupportUser_L: Llamando a la API con requestID:", requestID);
            SupportUserService.listSupportUsers(requestID).then(function (resp) {
                console.log("TicSupportUser_L: Respuesta recibida. Status:", resp.status, "Data length:", resp.data ? resp.data.length : 0);
                if (resp.status == 200) {
                    self.supportUsers = resp.data;
                    if (!self.supportUsers || self.supportUsers.length === 0) {
                        console.warn("TicSupportUser_L: No se encontraron usuarios de soporte activos (array vacío).");
                    }
                    // Initialize with current item's UsrDevolutionID if set, otherwise fallback to current user
                    if (self.item && self.item.UsrDevolutionID) {
                        self.selectedSupportUsrID = self.item.UsrDevolutionID;
                    } else {
                        self.selectedSupportUsrID = self.$fun.getUserID();
                    }
                    
                    // Pre-populate if not set
                    if (self.item && !self.item.UsrDevolutionID) {
                        const currentTech = self.supportUsers.find(function (u) { return u.UsrID == self.selectedSupportUsrID; }) || self.$fun.getUserInfo();
                        self.$set(self.item, 'UsrDevolutionID', self.selectedSupportUsrID);
                        self.$set(self.item, 'UsrDevolutionName', currentTech.NtpFullName || currentTech.fullName);
                        self.$set(self.item, 'UsrDevolutionPrsDocumentNumber', currentTech.PrsDocumentNumber || currentTech.documentNumber);
                    }
                } else {
                    console.error("TicSupportUser_L: Respuesta inesperada del servidor. Status:", resp.status);
                }
            }).catch(function (error) {
                console.error("TicSupportUser_L: Error al cargar técnicos de soporte.", error);
            });
        },
        onSupportUserChanged(usrID) {
            if (usrID) {
                const selected = this.supportUsers.find(function (u) { return u.UsrID == usrID; });
                if (selected) {
                    this.$set(this.item, 'UsrDevolutionID', selected.UsrID);
                    this.$set(this.item, 'UsrDevolutionName', selected.NtpFullName);
                    this.$set(this.item, 'UsrDevolutionPrsDocumentNumber', selected.PrsDocumentNumber);
                }
            } else {
                // Cleared selection: fallback to current user
                this.$set(this.item, 'UsrDevolutionID', this.$fun.getUserID());
                this.$set(this.item, 'UsrDevolutionName', this.$fun.getUserInfo().NtpFullName);
                this.$set(this.item, 'UsrDevolutionPrsDocumentNumber', this.$fun.getUserInfo().PrsDocumentNumber);
            }
        }, */
    },
    watch: {
        dialogSignatureUser(newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    this.$refs.signaturePadUser?.resizeCanvas();
                });
            }
        },
        dialogSignatureResponsible(newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    this.$refs.signaturePadResponsible?.resizeCanvas();
                });
            }
        }
    },
    computed: {
        formattedEanTextObservationDevolution() {
            if (!this.EanTextObservationDevolution) return "";
            return this.EanTextObservationDevolution.replace(/\n/g, "<br>");
        },
        sortedItemsDetail() {
            if (!this.item || !this.item.ItemsDetail) return [];
            var self = this;
            return this.item.ItemsDetail.slice().sort(function (a) {
                return a.CgeTypeEquipment == self.CELLPHONE_TYPE_ID ? 1 : -1;
            });
        },
        hasCellphone() {
            var self = this;
            return this.item && this.item.ItemsDetail && this.item.ItemsDetail.some(function (d) {
                return d.CgeTypeEquipment == self.CELLPHONE_TYPE_ID;
            });
        }
    },

    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    mounted() {
        console.log("PdfDevolution.vue:mounted() - this.item:", this.item);
        document.addEventListener("click", this.handleClickOutside);
        // this.loadSupportUsers();

        GenUploadFiles.getFile("routeTIInfraestructura", this.item.EanSignatureUserDevolution, true)
            .then(base64 => {
                this.EanSignatureUserDevolutionDB = base64;
            })
            .catch(error => console.error("Error al obtener imagen:", error));

        GenUploadFiles.getFile("routeTIInfraestructura", this.item.EanSignatureResponsibleDevolution, true)
            .then(base64 => {
                this.EanSignatureResponsibleDevolutionDB = base64;
            })
            .catch(error => console.error("Error al obtener imagen:", error));

        GenUploadFiles.getFile("routeTIInfraestructura", this.item.EanFingerPrintUserDevolution, true)
            .then(base64 => {
                this.EanFingerPrintUserDevolutionDB = base64;
            })
            .catch(error => console.error("Error al obtener imagen:", error));

        GenUploadFiles.getFile("routeTIInfraestructura", this.item.EanFingerPrintResponsibleDevolution, true)
            .then(base64 => {
                this.EanFingerPrintResponsibleDevolutionDB = base64;
            })
            .catch(error => console.error("Error al obtener imagen:", error));

        _sGenParam
            .search({ PrmName: "rootFolderId" }, this.$fun.getUserID())
            .then((resp) => {
                if (resp.status == 200) {
                    this.rootFolderId = resp.data.PrmValue;
                    console.log(this.rootFolderId);
                }
            });

        _sGenParam
            .search({ PrmName: "client_id" }, this.$fun.getUserID())
            .then((resp) => {
                if (resp.status == 200) {
                    this.client_id = resp.data.PrmValue;
                    console.log(this.client_id);
                }
            });

        this.getData();
        this.EanTextObservationDevolution = this.item.EanTextObservationDevolution || "";
    }
}
</script>